export default {"src":"/_next/static/media/search.931d4e1e.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};